<template>
  <a-row :gutter="24" style="height: 100%">
    <a-col :md="24" :sm="24" style="height: 100%">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表编号')">
                <j-input :placeholder="$t('表编号模糊查询')" v-model="queryParam.meterId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表口径')">
                <a-select v-model="queryParam.mtCaliber" :placeholder="$t('请选择表口径')">
                  <a-select-option v-for="data in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                    DN{{ data.mtCaliber }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户编号')">
                <j-input :placeholder="$t('用户编号模糊查询')" v-model="queryParam.userId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户姓名')">
                <j-input :placeholder="$t('用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户类型')">
                <a-select v-model="queryParam.userType" :placeholder="$t('请选择用户类型')">
                  <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                    {{ data.utName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="flex flex-center" style="margin-bottom: 15px">
        <div class="flex-item" style="height: 80px" v-for="item in totalList" :key="item.key">
          <div
            class="flex-center"
            style="height: 100%; background: #e6f7ff; border: 1px solid #91d5ff; justify-content: space-around"
          >
            <div>
              <div class="flex-center" style="color: #999999">{{ item.title }}</div>
              <div class="flex-center">
                <span class="" style="margin-left: 10px; font-size: 24px; font-weight: 500">{{ item.num }}</span>
                <span class="unit" style="color: #999999">{{ item.unit }}</span>
              </div>
            </div>
            <div>
              <span style="color: #52c41a" v-if="item.upOrDown > 0">
                <a-icon type="caret-up" theme="filled" />
                {{ item.upOrDown }}%
              </span>
              <span style="color: #ff4d4f" v-else-if="item.upOrDown < 0">
                <a-icon type="caret-down" theme="filled" />
                {{ item.upOrDown }}%
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- table区域-begin -->
      <div class="table-fixed">
        <a-table
          ref="table"
          size="middle"
          :scroll="{ x: true }"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :components="drag(columns)"
          @change="handleTableChange"
        >
          <template slot="userStateSlot" slot-scope="text">
            <a-button :class="text == 1 ? 'normalbg-status' : text == 0 ? 'unactivebg-status' : ''">
              {{ text == 1 ? $t('已激活') : text == 0 ? $t('未激活') : '' }}
            </a-button>
          </template>
          <span slot="action" slot-scope="text, record" class="action">
            <a @click="handleUserAnalysis(record)">{{ $t('用户分析') }}</a>
          </span>
        </a-table>
      </div>
      <!-- 地图 -->
      <div style="width: 100%; height: 400px" id="amapDiv">
        <baidu-map
          :center="center"
          :zoom="zoom"
          :style="{ height: '100%' }"
          :scroll-wheel-zoom="scrollZoom"
          NavigationControlType="BMAP_NAVIGATION_CONTROL_LARGE"
          @ready="mapReady"
        >
          <!-- 缩放控件 -->
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
          <!-- 定位控件 -->
          <bm-geolocation
            anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
            :showAddressBar="true"
            :autoLocation="true"
          ></bm-geolocation>
          <!-- 比例尺控件 -->
          <bm-scale anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-scale>
          <!-- 信息窗体 -->
          <bm-info-window :position="position" :show="show" @close="infoWindowClose" @open="infoWindowOpen">
            <div style="width: 100%; display: flex; justify-content: space-between; font-weight: bold">
              <div style="flex: 1">
                <div>{{ $t('用户名称') }}：{{ mapInfo.userName }}</div>
                <div>{{ $t('用户类型') }}：{{ mapInfo.userTypeName }}</div>
                <div>{{ $t('表编号') }}：{{ mapInfo.meterId }}</div>
                <div>{{ $t('表口径') }}：{{ 'DN' + mapInfo.mtCaliber }}</div>
                <div>{{ $t('用户经度') }}：{{ mapInfo.userMeterLng }}</div>
                <div>{{ $t('用户纬度') }}：{{ mapInfo.userMeterLat }}</div>
              </div>
            </div>
          </bm-info-window>
        </baidu-map>
      </div>
      <UserAnalysisModal ref="UserAnalysisModalRef"></UserAnalysisModal>
    </a-col>
  </a-row>
</template>
  <script>
import { getAction, deleteAction, postAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import TableDragResize from '@/mixins/TableDragResize'
import JInput from '@/components/jeecg/JInput'
import configService from '@/utils/service/config.service'
import { listSize } from '@/utils/util'
import { Mn100FkStatusObj } from '@/utils/constants/protocolConstant'
import { isUndefinedAndNull, isUndefined, isEmptyObject } from '@/utils/validate'
import UserAnalysisModal from './UserAnalysisModal.vue'
import Vue from 'vue'
export default {
  name: 'allIndex',
  mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
  components: {
    JInput,
    UserAnalysisModal
  },
  data() {
    return {
      collapsed: false,
      //列设置
      settingColumns: [],
      data: [],
      visible: false,
      userPriceCode: [], // 价格编码
      description: 'meter_userinfo管理页面',
      url: {
        list: '/jeecg-charge/importantUser/list',
        userCaliberList: '/jeecg-charge/meter/meterCaliber/list', //表口径请求地址
        userTypeList: '/jeecg-charge/meter/meterUserType/list', //类别编码列表接口
        getCount: '/jeecg-charge/importantUser/getCount',
        userinfolist: "/jeecg-charge/meter/meterUserinfo/list",
      },
      userCaliberList: [],
      userTypeList: [], //  类型编码
      // 统计项数值（totalList 改为 computed 后由此响应式承接）
      statData: {
        totalUsage: '15234.6',
        totalUsageUpOrDown: '',
        avgFlow: '2.5',
        avgFlowUpOrDown: '',
        reportRate: '95.8',
        alarmCount: '12',
      },
      BMap: '',
      map: '',
      center: { lng: 118.904, lat: 31.915 }, //中心坐标
      centerPoint: { lng: 118.904, lat: 31.915 },
      zoom: 4, //初始缩放比
      scrollZoom: true, //允许鼠标滚轮缩放
      mapInfo: {},
      position: {},
      show: false,
      iconList: {
        0: require('@/assets/inspectionImage/circle_red.png'),
        1: require('@/assets/inspectionImage/circle_green.png'),
        2: require('@/assets/inspectionImage/circle_gray.png'),
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${configService.apiUrl}/${this.url.importExcelUrl}`
    },
    // i18n：统计项标题使用 computed 以响应语言切换
    totalList() {
      return [
        { key: 1, title: this.$t('总用水量'), num: this.statData.totalUsage, unit: 'm³', upOrDown: this.statData.totalUsageUpOrDown },
        { key: 2, title: this.$t('平均流量'), num: this.statData.avgFlow, unit: 'm³/h', upOrDown: this.statData.avgFlowUpOrDown },
        { key: 3, title: this.$t('设备上报率'), num: this.statData.reportRate, unit: '%', upOrDown: '' },
        { key: 4, title: this.$t('告警数量'), num: this.statData.alarmCount, unit: this.$t('个'), upOrDown: '' },
      ]
    },
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: this.$t('排名'),
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('用户姓名'),
          align: 'center',
          dataIndex: 'userName',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户类型'),
          align: 'center',
          dataIndex: 'userTypeName',
          width: 120,
          ellipsis: true,
        },
        {
          title: this.$t('表编号'),
          align: 'center',
          dataIndex: 'meterId',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('表口径'),
          align: 'center',
          dataIndex: 'mtCaliber',
          customRender: text => 'DN' + text,
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('安装地址'),
          align: 'center',
          dataIndex: 'userAddr',
          width: 200,
          ellipsis: true,
        },
        {
          title: this.$t('累计流量(m³)'),
          align: 'center',
          dataIndex: 'flowSum',
          width: 150,
          ellipsis: true,
        },
        // {
        //   title: '瞬时流量(m³)',
        //   align: 'center',
        //   dataIndex: 'wtPrice',
        //   width: 150,
        //   ellipsis: true,
        // },
        {
          title: this.$t('阀门状态'),
          align: 'center',
          dataIndex: 'valveState',
          customRender: (t, r, index) => {
            const data = Mn100FkStatusObj
            if (isUndefined(data[t])) {
              return this.$t('未知')
            }
            return this.$t(data[t])
          },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户状态'),
          align: 'center',
          dataIndex: 'userState',
          scopedSlots: { customRender: 'userStateSlot' },
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('昨日用水量(m³)'),
          align: 'center',
          dataIndex: 'lastDayFlowSum',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('变动百分比'),
          align: 'center',
          dataIndex: 'rate',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('最后上报时间'),
          align: 'center',
          dataIndex: 'lastReportTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  methods: {
    init(params) {
      this.queryUserCaliberList()
      this.queryUserTypeList()
      this.queryParam = Object.assign({},this.queryParam, params)
      this.loadData(1)
      this.getCount()
    },
    getCount() {
      getAction(this.url.getCount, { areaId: this.areaId }).then(res => {
        if (res.success) {
          let result = res.result
          for (const key in result) {
            if (key == 'flowSum') {
              this.statData.totalUsage = result[key]
            }
            if (key == 'flowSumRate') {
              this.statData.totalUsageUpOrDown = result[key]
            }
            if (key == 'averageFlow') {
              this.statData.avgFlow = result[key]
            }
            if (key == 'averageFlowRate') {
              this.statData.avgFlowUpOrDown = result[key]
            }
            if (key == 'deviceReportRate') {
              this.statData.reportRate = result[key]
            }
            if (key == 'alarmedCount') {
              this.statData.alarmCount = result[key]
            }
          }
        }
      })
    },
    queryUserCaliberList() {
      //表口径请求
      let params = {}
      params.pageNo = 1
      params.pageSize = listSize
      params.column = 'mtCaliber'
      params.order = 'asc'
      getAction(this.url.userCaliberList, params).then(res => {
        if (res.success) {
          this.userCaliberList = res.result.records
        }
      })
    },
    queryUserTypeList() {
      //类别编码
      let params = {}
      params.pageNo = 1
      params.pageSize = listSize
      getAction(this.url.userTypeList, params).then(res => {
        if (res.success) {
          this.userTypeList = res.result.records
        }
      })
    },
    //地图默认方法
    mapReady({ BMap, map }) {
      let that = this
      this.BMap = BMap
      this.map = map
      map.enableDragging()
      map.enableScrollWheelZoom()
      map.enableDoubleClickZoom()
      map.enablePinchToZoom()
      map.enableKeyboard()
      map.clearOverlays()
      let params = this.getQueryParams()
      params.pageSize = 1000
      getAction(this.url.list, params).then(res => {
        if (res.success) {
          that.dataSource = res.result.records
          that.dataSource.forEach(item => {
            if (item.userMeterLng && item.userMeterLat) {
              var point = {
                lng: item.userMeterLng,
                lat: item.userMeterLat,
              }
              let myIcon = new BMap.Icon(
                //也可以设置不同坐标点上的icon，需要自己定义
                that.iconList[item.userState] || require('@/assets/inspectionImage/circle_gray.png'),
                new BMap.Size(40, 40), //图标可视区域大小
                { anchor: new BMap.Size(18, 18) } //图标定位点相对于图标左上角的偏移量
              )
              myIcon.setImageSize(new BMap.Size(30, 30)) // 设置icon大小
              var marker = new BMap.Marker(point, { icon: myIcon }) // 创建标注
              map.addOverlay(marker) // 将标注添加到地图中
              //icon标识内容位置
              let label = new BMap.Label(item.meterId, { offset: new BMap.Size(3, 0) })
              // 文本标识样式
              label.setStyle({
                // fontWeight: 600,
                fontSize: '14px',
                color: 'black',
                backgroundColor: '#fff',
                border: '1px solid #000',
                display: 'none',
              })
              marker.setLabel(label) // 为icon添加文本标识
            }
          })
        }
      })
      this.map.addEventListener('click', e => {
        that.mapInfo = that.dataSource.find(al => al.meterId == e.cb.Bc.textContent)
        that.position = {
          lng: that.mapInfo && that.mapInfo.userMeterLng,
          lat: that.mapInfo && that.mapInfo.userMeterLat,
        }
        that.show = true
      })
    },
    // 关闭窗体
    infoWindowClose() {
      this.show = false
    },
    infoWindowClosedb() {
      this.dbShow = false
    },
    // 打开窗体
    infoWindowOpen() {
      this.show = true
    },
    handleUserAnalysis(record) {
      getAction(this.url.userinfolist,{meterId:record.meterId}).then(res=>{
        if(res.success){
          this.$nextTick(() => {
            this.$refs.UserAnalysisModalRef.init(res.result.records[0])
          })
        }else{
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>
  <style scoped lang="less">
.drawer-bootom-button {
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.qrcodeInfo {
  color: #222;
  margin: 5px 0;
}
</style>
  <style scoped>
.my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}
</style>
  <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
/* .new-table-card .ant-card-body .table-fixed {
  height: calc(100% - 207px);
} */
</style>